module.exports = __webpack_public_path__ + "img/analytics-location@2x.c44f4d09.jpg";